import { css } from 'styled-components';
import {
  getSpacing, SpacingName,
} from '@doveit/lego';

export const mobileSearchBox = ({
  hasNavigation,
}) => css`
  position: absolute;
  top: ${hasNavigation ? '4rem' : '1rem'};
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
`;

export const mobileSearchContent = () => css`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const mobileSearchHeader = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, SpacingName.SMALL)}
  flex-shrink: 0;
  width: 100%;
  border-bottom: 1px solid ${theme.palettes.neutrals.light};
`;

export const mobileSearchList = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.SMALL, 0])}
  flex-grow: 1;
  min-height: 7.5rem;
  overflow-y: scroll;
`;
